import { searchOrderModel } from '../../api';
import {
  SEARCH_EVENTS,
  sendSearchApiEvents,
} from '../../helpers/analytics/search.analytics';
import toast from 'react-hot-toast';

const getUniqueFlag = (order) => {
  const orderId = order?.order?.order_id;
  const cartId = order?.order?.cart_id;
  return orderId ? orderId : cartId;
};

const getUniqueOrders = (allOrders = [], newOrders = []) => {
  const orderList = [...allOrders];
  const idHashMap = {};
  orderList.forEach((order) => {
    const uniqueIdFlag = getUniqueFlag(order);
    idHashMap[uniqueIdFlag] = order;
  });
  newOrders.forEach((order) => {
    const uniqueIdFlag = getUniqueFlag(order);
    if (!(uniqueIdFlag in idHashMap)) {
      idHashMap[uniqueIdFlag] = order;
      orderList.push(order);
    }
  });
  return orderList;
};

export const SET_NEW_UI = 'SET_NEW_UI';
export const setNewUI = (value) => ({
  type: SET_NEW_UI,
  value,
});

export const IS_REVAMP_ENABLED = 'IS_REVAMP_ENABLED';
export const isRevampEnabled = (value) => ({
  type: IS_REVAMP_ENABLED,
  value,
});

export const IS_LIVE_ORDERS_VIEW_ENABLED = 'IS_LIVE_ORDERS_VIEW_ENABLED';
export const isLiveOrdersViewEnabled = (value) => ({
  type: IS_LIVE_ORDERS_VIEW_ENABLED,
  value,
});

export const SET_SHOW_ARCHIVED_DETAILS = 'SET_SHOW_ARCHIVED_DETAILS';
export const setShowArchivedDetails = (value) => ({
  type: SET_SHOW_ARCHIVED_DETAILS,
  value,
});

export const SET_INVALID_SEARCH = 'SET_INVALID_SEARCH';
export const setInvalidSearch = (value) => ({
  type: SET_INVALID_SEARCH,
  value,
});

export const SET_SHOW_EMPTY_STATE = 'SET_SHOW_EMPTY_STATE';
export const setShowEmptyState = (value) => ({
  type: SET_SHOW_EMPTY_STATE,
  value,
});

export const SET_WFH = 'SET_WFH';
export const setWFH = (value) => ({ type: SET_WFH, value });

export const SET_ERROR = 'SET_ERROR';
export const setError = (value) => ({ type: SET_ERROR, value });

export const resetState = (isReset) => (dispatch) => {
  if (!isReset) return;
  dispatch(setError(false));
  dispatch(setOrders(null));
  dispatch(setNewUserData(null));
  dispatch(setInvalidSearch(false));
  dispatch(setLoading(false));
};

export const getCustomerAlerts = (params) => (dispatch, getState) => {
  const { ordersState } = getState();
  return searchOrderModel
    .getCustomerAlerts(params)
    .then((response) => {
      if (!response || (response && response.isError === true)) {
        toast.error(response.message);
        dispatch(setLoading(false));
        return;
      }
      let alertRes = response?.alerts || [];
      dispatch(setLoading(false));
      dispatch(setAlerts(alertRes));
      dispatch(showBlockingPopup(true));
      return response;
    })
    .catch((err) => {
      toast.error(err.message);
      dispatch(setLoading(false));
      return err;
    });
};

const getPayloadForAlerts = (params, uniqueOrders) => {
  // extracting order id from search url because it is not directly being added from lifeline in case of smartplug
  const urlSearchParams = new URLSearchParams(window.location.search);
  const smartplugUrlParams = Object.fromEntries(urlSearchParams.entries());
  const dashboardMode = window.dashboard.mode;

  let baseOrderId = null;
  if (dashboardMode === 'smartplug') baseOrderId = smartplugUrlParams?.order;
  else
    params?.type === 'order_id'
      ? (baseOrderId = params.value)
      : (baseOrderId = null);

  const resultOrders = [];
  for (let i = 0; i < uniqueOrders.length; i++) {
    const order = uniqueOrders[i];
    resultOrders.push({
      order_id: order.order?.order_id,
      cart_id: order.order?.cart_id,
    });
  }

  return {
    base_order_id: baseOrderId,
    result_orders: resultOrders,
    mode: dashboardMode,
  };
};

export const getSearchOrders = (params) => (dispatch, getState) => {
  const { ordersState } = getState();
  const { orders } = ordersState;
  let allOrders = (orders && orders) || [];
  return searchOrderModel
    .getSearchOrders(params)
    .then((response) => {
      if (!response || (response && response.isError === true)) {
        sendSearchApiEvents(SEARCH_EVENTS.SEARCH_ORDER_DETAILS_FAILURE, {
          params: JSON.stringify(params),
        });
        dispatch(setError(response));
        dispatch(setLoading(false));
        return;
      }
      sendSearchApiEvents(SEARCH_EVENTS.SEARCH_ORDER_DETAILS_SUCCESS, {
        params: JSON.stringify(params),
      });
      let searchRes = response.orders ? response.orders : [];
      dispatch(setLoading(false));
      if (response.new_user_view && response.new_user_view.user_id) {
        dispatch(setNewUserData(response.new_user_view));
        dispatch(
          setCxDetails({
            customer_id: response.new_user_view.user_id,
          }),
        );
      }

      if (searchRes && !searchRes.length && !response.new_user_view.user_id) {
        dispatch(setInvalidSearch(true));
        return;
      }
      dispatch(isLiveOrdersViewEnabled(response?.show_live_order_task_section));
      dispatch(isRevampEnabled(response?.revamp_enabled));
      dispatch(
        setNewUI(response?.revamp_enabled ? response?.new_ui_preference : true),
      );
      dispatch(setShowArchivedDetails(response?.show_archived_details));
      dispatch(setHasMoreOrders(response.has_more));
      dispatch(setNextCursor(response.next_cursor));
      dispatch(setOrders(getUniqueOrders(allOrders, searchRes)));
      if (searchRes?.length)
        dispatch(
          setCxDetails({
            customer_id: searchRes[0].user?.id,
            customer_name: searchRes[0].user?.name,
          }),
        );

      dispatch(setWFH(response.is_wfh));
      dispatch(setAnnouncements(response.announcements));
      dispatch(setShowEmptyState(false));
      dispatch(
        getCustomerAlerts(
          getPayloadForAlerts(params, getUniqueOrders([], searchRes)),
        ),
      );
      return response;
    })
    .catch((err) => {
      sendSearchApiEvents(SEARCH_EVENTS.SEARCH_ORDER_DETAILS_FAILURE, {
        error: JSON.stringify(err),
        params: JSON.stringify(params),
      });
      dispatch(
        setError({
          message: err.message,
          uuid: 'NA',
        }),
      );
      dispatch(setLoading(false));
      return err;
    });
};

export const SET_ORDERS = 'SET_ORDERS';
export const setOrders = (orders) => ({
  type: SET_ORDERS,
  orders,
});

export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const setCxDetails = (cxDetails) => ({
  type: SET_CUSTOMER_DETAILS,
  cxDetails,
});

export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';
export const setAnnouncements = (announcements) => ({
  type: SET_ANNOUNCEMENTS,
  payload: announcements,
});

export const SET_NEW_USER_DATA = 'SET_NEW_USER_DATA';
export const setNewUserData = (data) => ({
  type: SET_NEW_USER_DATA,
  payload: data,
});

export const SET_ALERTS = 'SET_ALERTS';
export const setAlerts = (alerts) => ({
  type: SET_ALERTS,
  payload: alerts,
});

export const SET_HAS_MORE_ORDERS = 'SET_HAS_MORE_ORDERS';
export const setHasMoreOrders = (hasMore) => ({
  type: SET_HAS_MORE_ORDERS,
  hasMore,
});

export const SET_NEXT_CURSOR = 'SET_NEXT_CURSOR';
export const setNextCursor = (nextCursor) => ({
  type: SET_NEXT_CURSOR,
  nextCursor,
});

export const SET_LOADING = 'SET_LOADING';
export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  isLoading,
});

export const SHOW_BLOCKING_POPUP = 'SHOW_BLOCKING_POPUP';
export const showBlockingPopup = (value) => ({
  type: SHOW_BLOCKING_POPUP,
  value,
});

export const SET_SHOW_SHIMMER = 'SET_SHOW_SHIMMER';
export const setShowShimmer = (isShowShimmer) => ({
  type: SET_SHOW_SHIMMER,
  isShowShimmer,
});

export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const setSearchType = (searchType) => ({
  type: SET_SEARCH_TYPE,
  searchType,
});

export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const setSearchValue = (value) => ({
  type: SET_SEARCH_VALUE,
  value,
});

export const SET_IS_TIMELINE_UPDATED = 'SET_IS_TIMELINE_UPDATED';
export const setIsTimelineUpdated = (value) => ({
  type: SET_IS_TIMELINE_UPDATED,
  value,
});

export const SET_CALL_ALERT_DATA = 'SET_CALL_ALERT_DATA';
export const setCallAlertData = (value) => ({
  type: SET_CALL_ALERT_DATA,
  value,
});
